import { Typography } from '@mui/material';

interface ISpecialEntitlementState {
  text: string;
}

export const SpecialEntitlementState = ({ text }: ISpecialEntitlementState) => {
  return (
    <Typography
      bgcolor={'purple2.shade_100'}
      border={'1px solid'}
      borderColor={'purple2.shade_200'}
      borderRadius={'6px'}
      padding={'10px'}
      variant={'body6'}
    >
      {text}
    </Typography>
  );
};
